import { FC, ReactNode } from "react";
import {
  StyledResult,
} from "./styled";

type Props = {
  title: string;
  message?: string;
  image: string;
  children?: ReactNode;
};

const Result: FC<Props> = ({ title, message, image, children }) => (
  <StyledResult>
    <img src={`/images/${image}`} alt={title} />
    <h2>{title}</h2>
    {!!message && <p>{message}</p>}
    {children}
  </StyledResult>
);

export default Result;